document.addEventListener('turbolinks:load', () => {
  // eslint-disable-next-line func-names
  $('#last-3-days-published-at').on('change', function () {
    window.location = $(this).val();
  });
});
